/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useLayoutEffect, useCallback, useState } from "react";

import { useParams } from "react-router-dom";
import Container from "react-bootstrap/Container";

import { useLoading } from "../../../../shared/hooks/useLoading";

import { ILayers } from "../../../../shared/interfaces/ILayers";
import {
    IProperty,
    IPropertyGeom,
} from "../../../../shared/interfaces/IProperties";
import { LayersApiService } from "../../../../shared/services/api/layers-api.service";
import { PropertiesApiService } from "../../../../shared/services/api/properties-api.service";
import { DisclaimerPalmeira } from "../../../../components/page-releated/consulta-previa/disclaimer/palmeira";
import { PalmeiraPrincipaisDados } from "../../../../components/page-releated/consulta-previa/palmeira/dados";
import { PalmeiraAlvaras } from "../../../../components/page-releated/consulta-previa/palmeira/alvaras";
import { PalmeiraLeiZoneamento } from "../../../../components/page-releated/consulta-previa/palmeira/lei-zoneamento";
// import { ParkingLot } from "../../../../components/page-releated/consulta-previa/estacionamento";
import { PalmeiraSolo } from "../../../../components/page-releated/consulta-previa/palmeira/solo";
import { PalmeiraGaragem } from "../../../../components/page-releated/consulta-previa/palmeira/garagem";
import { ConsultaPreviaStyle } from "../../../../components/page-releated/consulta-previa/header/styles";
import { HeaderPalmeira } from "../../../../components/page-releated/consulta-previa/palmeira/header";
import { PalmeiraLeiEstacionamento } from "./estacionamento";
// import { PalmeiraAnexo1 } from "../../../../components/page-releated/consulta-previa/palmeira/anexo1";
// import { showToast } from "../../../../components/global/toast";
import { IAlvara, ICnaesPalmeira } from "../../../../shared/interfaces/IBCI";
import { Zoneamento } from "../../../../components/page-releated/consulta-previa/zoneamento";
import { PalmeiraCnaes } from "../../../../components/page-releated/consulta-previa/palmeira/cnaes";

export const PalmeiraConsultaPrevia: React.FC = () => {
    const { setLoading } = useLoading();

    const { subscription } = useParams<{
        subscription: string | undefined;
    }>();

    const [property, setProperty] = useState<IProperty>();
    const [propertyGeom, setPropertyGeom] = useState<IPropertyGeom>();
    const [layers, setLayers] = useState<ILayers[]>();
    const [alvara, setAlvara] = useState<IAlvara>();
    const [cnaes, setCnaes] = useState<ICnaesPalmeira[]>();

    const fetchConsultaPrevia = useCallback(async () => {
        document.title = `CONSULTA PRÉVIA - PALMEIRA - ${subscription}`;
        try {
            setLoading(true);

            if (subscription) {
                const {
                    property: propertyResponse,
                    geom: propertyGeomResponse,
                    alvara: alvaraResponse,
                    cnaesPalmeira: cnaesResponse,
                } = await PropertiesApiService.getPropertyConsultaPrevia(
                    subscription
                );
                const layersResponse = await LayersApiService.getLayers(
                    `where={"cam_ativa_consultaprevia":"true"}&orderBy=ASC:cam_ordem&`
                );
                setCnaes(cnaesResponse);

                setAlvara(alvaraResponse);

                setProperty(propertyResponse);

                setPropertyGeom(propertyGeomResponse);

                setLayers(layersResponse.data);
            }
        } finally {
            setLoading(false);
        }
    }, [setLoading, subscription]);

    useLayoutEffect(() => {
        fetchConsultaPrevia();
    }, [fetchConsultaPrevia]);

    return (
        <>
            <ConsultaPreviaStyle />
            <Container>
                {/* <HeaderPalmeira />
                <DisclaimerPalmeira />
                <ZoneamentoPalmeira
                    propertyInfo={property}
                    propertyGeom={propertyGeom}
                    layers={layers}
                    legends={allLegends}
                />
                <PalmeiraPrincipaisDados propertyInfo={property} />
                <PalmeiraAlvaras propertyInfo={property} />
                <PalmeiraLeiZoneamento propertyInfo={property} />
                <PalmeiraSolo />

                <ParkingLot />
                <PalmeiraGaragem /> */}
                <table>
                    <thead>
                        <tr>
                            <th>
                                <HeaderPalmeira />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <DisclaimerPalmeira />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <Zoneamento
                                    propertyInfo={property}
                                    propertyGeom={propertyGeom}
                                    layers={layers}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <PalmeiraPrincipaisDados
                                    propertyInfo={property}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <PalmeiraAlvaras alvara={alvara} />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <PalmeiraLeiZoneamento
                                    propertyInfo={property}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <PalmeiraCnaes cnaes={cnaes} />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <PalmeiraSolo />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <PalmeiraLeiEstacionamento
                                    propertyInfo={property}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <PalmeiraGaragem />
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td className="italic">
                                EMITIDO EM ►
                                {new Date(Date.now()).toLocaleDateString(
                                    "pt-BR"
                                )}
                            </td>
                        </tr>
                        {property && property.inscricaoimobiliaria && (
                            <tr className="italic">
                                <td>
                                    INSCRIÇÃO ► {property.inscricaoimobiliaria}
                                </td>
                            </tr>
                        )}
                    </tfoot>
                </table>
            </Container>
        </>
    );
};
